// extracted by mini-css-extract-plugin
export default {"button":"restart-button_button__gv84p"};